import { useEffect, useState } from 'react';
import { Card, CardSubtitle, CardTitle, Wordmark } from '@keobook/ui';

/**
 * Entry point for the public "Try the demo" flow. Reads the short-lived demo
 * token + clientId from the URL hash (hash, not query, so the values never
 * land in server logs or referrer headers), stores the token, and hands the
 * user off to the dashboard with a hard navigation so the AuthProvider picks
 * the demo token up cleanly on remount.
 */
const DEMO_KEY = 'kb_demo_token';

export function DemoEntry() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = hash.get('token');
    if (!token) {
      setError(
        'This demo link is missing its token. Try clicking "Try the demo" again from the marketing site.',
      );
      return;
    }
    try {
      localStorage.setItem(DEMO_KEY, token);
    } catch {
      setError(
        'Your browser is blocking storage — we cannot start the demo. Try a different browser or window.',
      );
      return;
    }
    // replace() (not href=) avoids leaving /demo in the back-history. The
    // AuthProvider on /dashboard reads localStorage in its lazy initializer.
    window.location.replace('/dashboard');
  }, []);

  return (
    <main className="kb-auth-page">
      <div className="kb-auth-container">
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Wordmark size="lg" tagline="Setting up your demo" />
        </div>
        <Card size="xl">
          {error ? (
            <>
              <CardTitle>Demo could not start</CardTitle>
              <CardSubtitle>{error}</CardSubtitle>
            </>
          ) : (
            <>
              <CardTitle>Preparing your sample books…</CardTitle>
              <CardSubtitle>
                One moment — we are putting a representative month of transactions in front of you.
              </CardSubtitle>
            </>
          )}
        </Card>
      </div>
    </main>
  );
}
